export function _isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
  );
  return flag;
}

export function debounce(fn, delay) {
  let timer;
  return function() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.call(this, ...arguments);
    }, delay);
  };
}



// WEBPACK FOOTER //
// ./src/utils/index.js